import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href="https://pagos.avanzalab.online/cart/53128638628154:1" className={`
        inline-block w-full md:w-auto text-center
        bg-yellow-500 hover:bg-yellow-400 text-black 
        font-black text-xl md:text-2xl 
        py-4 px-8 rounded-lg shadow-[0_8px_0_#b45309,0_15px_20px_rgba(0,0,0,0.4)]
        active:shadow-[0_0px_0_#b45309,0_0px_0px_rgba(0,0,0,0.4)] active:translate-y-2
        transition-all duration-150 uppercase tracking-wide
        ${className}
      `} data-id="element-43">
      {children}
    </a>;
}